import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchTodayAttendance } from '../api/Attendance';
import { Attendance } from '../types/Attendance';

type UserId = number | string | undefined | null;

export function useTodayAttendance(userId: UserId) {
  const numericUserId = useMemo(() => {
    if (userId === undefined || userId === null || userId === '') return undefined;
    const value = typeof userId === 'string' ? Number.parseInt(userId, 10) : userId;
    return Number.isFinite(value) ? value : undefined;
  }, [userId]);
  const [attendance, setAttendance] = useState<Attendance | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (numericUserId === undefined) {
      setAttendance(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const records = await fetchTodayAttendance(numericUserId);
      setAttendance(Array.isArray(records) && records.length > 0 ? records[0] : null);
    } catch (error) {
      console.error('Failed to load today attendance:', error);
      setAttendance(null);
    } finally {
      setLoading(false);
    }
  }, [numericUserId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { attendance, loading, refresh };
}
